module.exports = {
  getUserInfo: {
    url: '/userinfo/detail'
  },
  login: {
    url: '/user/login',
    method: 'post',
    dataType: 'form'
  },
  bindingDevice: {
    url: '/binding/device',
    method: 'put'
  },
  getRechargePage: {
    url: '/recharge/record/page'
  },
  bindMobile: {
    url: '/bind/mobile',
    method: 'post'
  },
  setDeviceLocation: {
    url: '/user/set_location',
    method: 'post'
  }
};
